define('views/modules/profile/edit/account-info-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // src
    'services/user',
    'services/api',
    // views
    'views/parts/form/textbox',
    'views/parts/info-section',
    'views/parts/form/choices',
    'views/parts/form/datepicker',
    // templates
    'text!templates/modules/profile/edit/account-info-edit-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    User,
    API,
    // views
    VTextBox,
    VInfoSection,
    VChoices,
    VDatePicker,
    // templates
    TBaseInfoEditForm
) {

    var VBaseInfoEditForm = Backbone.View.extend({
        template: TBaseInfoEditForm,

        regions: {
            form: {
                firstname: '.firstname-input',
                lastname: '.lastname-input',
                email: '.email-input',
                password: '.password-input',
                supervisor: '.supervisor-input',
                expiration: '.expiration-input',
            }
        },
        initialize: function(opt) {
            this.options = opt || {};

            this.view = {
                info: new VInfoSection({
                    title: "supervisor:member-account-information",
                    content: this.template,
                }),
                form: {
                    firstname: new VTextBox({ label: 'form-profile-firstname', labelposition: "top", attribute: 'firstname', model: this.model, autofocus: true }),
                    lastname: new VTextBox({ label: 'form-profile-lastname', labelposition: "top", attribute: 'lastname', model: this.model }),
                    email: new VTextBox({ label: 'form-profile-email', attribute: 'email', labelposition: "top", model: this.model }),
                    password: new VTextBox({ label: 'form-profile-password', attribute: 'password', labelposition: "top", help: 'form-profile-password-help', type: "password", model: this.model }),
                }
            };

        },
        render: function() {

            // append the form
            this.assign(this.view.info, this.$el);

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.form.firstname, zone.form.$firstname)
                .assign(view.form.lastname, zone.form.$lastname)
                .assign(view.form.email, zone.form.$email)
                .assign(view.form.password, zone.form.$password);

            return this;
        },

    });

    return VBaseInfoEditForm;
});

